/*
Geo location related functionality
 */
export const getCurrentLocation = (t) => {
 return new Promise((resolve, reject) => {
  if (!navigator.geolocation) {
    reject(new Error(t('geolocationNotSupported')));
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const location = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy
      };
      resolve(location);
    },
    (error) => {
      let errorMessage;
      switch (error.code) {
        case error.PERMISSION_DENIED:
          errorMessage = t('userDeniedLocationAccess');
          break;
        case error.POSITION_UNAVAILABLE:
          errorMessage = t('locationInfoUnavailable');
          break;
        case error.TIMEOUT:
          errorMessage = t('locationTimeOut');
          break;
        default:
          errorMessage = t('unknownError');
          break;
      }
      reject(new Error(errorMessage));
    },
    { 
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 60000
    }
  );
 });
}